<template>
  <FloatingQuickPickButton @click="handleClick" />
</template>

<script lang="ts" setup>
type LotteryBaseQuickPickButtonProps = {
  onClick?: () => void
  validatePick?: QuickPickOptions['validateFn']
}

const { onClick, validatePick } = defineProps<LotteryBaseQuickPickButtonProps>()

const { fillPlaysWithQuickPick, getPlayIndex, plays, visiblePlayId } = usePlaySlip()

const currentPlay = computed(() => {
  const playIndex = getPlayIndex(visiblePlayId.value)
  return plays.value[playIndex]
})

const handleClick = () => {
  if (onClick) {
    onClick()
    return
  }

  const { perPlayAddOn, stake } = currentPlay.value
  fillPlaysWithQuickPick([visiblePlayId.value], {
    betType: perPlayAddOn?.value,
    stake,
    validateFn: validatePick,
  })
}
</script>
